// Phase 3 — carpool board API.
import client from "./client";

export const fetchCarpoolPosts = (abilityLevel) =>
  client.get("/carpool", { params: abilityLevel ? { abilityLevel } : {} }).then((r) => r.data);

export const createCarpoolPost = (post) => client.post("/carpool", post).then((r) => r.data);

export const deleteCarpoolPost = (postId) => client.delete(`/carpool/${postId}`).then((r) => r.data);
